/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListTimetableEventsParams,
  SchemaValidationErrorResponse,
  StandardError,
  TimetableEvent,
  TimetableEventCollection,
  TimetableEventCreateInput,
  TimetableEventDiscontinuePreview,
  TimetableEventUpdateInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Create a new timetable event for a specific calendar
 * @summary Create a new timetable event
 */
export const createTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    timetableEventCreateInput?: MaybeRefOrGetter<TimetableEventCreateInput>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
timetableEventCreateInput = toValue(timetableEventCreateInput);

      return axiosClient<TimetableEvent>(
      {url: `/timetable/calendars/${calendarId}/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timetableEventCreateInput, signal
    },
      );
    }




export const getCreateTimetableEventMutationKey = () => ['createTimetableEvent'] as const;

export const getCreateTimetableEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableEvent>>, TError,CreateTimetableEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTimetableEvent>>, TError,CreateTimetableEventMutationVariables, TContext> => {

const mutationKey = getCreateTimetableEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTimetableEvent>>, CreateTimetableEventMutationVariables> = (props) => {
          const {calendarId,data} = props ?? {};

          return  createTimetableEvent(calendarId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTimetableEventMutationResult = NonNullable<Awaited<ReturnType<typeof createTimetableEvent>>>
    export type CreateTimetableEventMutationBody = TimetableEventCreateInput | undefined
    export type CreateTimetableEventMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateTimetableEventMutationVariables = {calendarId: string;data?: TimetableEventCreateInput}

    /**
 * @summary Create a new timetable event
 */
export const useCreateTimetableEvent = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableEvent>>, TError,CreateTimetableEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTimetableEvent>>,
        TError,
        CreateTimetableEventMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTimetableEventMutationOptions(options), queryClient);
    }
    /**
 * Retrieve a list of timetable events for a specific calendar
 * @summary List timetable events for a calendar
 */
export const listTimetableEvents = (
    calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableEventsParams>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
params = toValue(params);

      return axiosClient<TimetableEventCollection>(
      {url: `/timetable/calendars/${calendarId}/events`, method: 'GET',
        params, signal
    },
      );
    }




export const getListTimetableEventsQueryKey = (calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableEventsParams>,) => {
    return [
    'timetable','calendars',calendarId,'events', ...(params ? [params] : [])
    ] as const;
    }


export const getListTimetableEventsQueryOptions = <TData = Awaited<ReturnType<typeof listTimetableEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>>(calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTimetableEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTimetableEventsQueryKey(calendarId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTimetableEvents>>> = ({ signal }) => listTimetableEvents(calendarId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTimetableEvents>>, TError, TData>
}

export type ListTimetableEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listTimetableEvents>>>
export type ListTimetableEventsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>


/**
 * @summary List timetable events for a calendar
 */

export function useListTimetableEvents<TData = Awaited<ReturnType<typeof listTimetableEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>>(
 calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTimetableEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTimetableEventsQueryOptions(calendarId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Delete a break_time event. Only break_time events can be deleted.
 * @summary Delete a timetable event
 */
export const deleteTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/events/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTimetableEventMutationKey = () => ['deleteTimetableEvent'] as const;

export const getDeleteTimetableEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableEvent>>, TError,DeleteTimetableEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableEvent>>, TError,DeleteTimetableEventMutationVariables, TContext> => {

const mutationKey = getDeleteTimetableEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTimetableEvent>>, DeleteTimetableEventMutationVariables> = (props) => {
          const {calendarId,id} = props ?? {};

          return  deleteTimetableEvent(calendarId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimetableEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimetableEvent>>>

    export type DeleteTimetableEventMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type DeleteTimetableEventMutationVariables = {calendarId: string;id: string}

    /**
 * @summary Delete a timetable event
 */
export const useDeleteTimetableEvent = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableEvent>>, TError,DeleteTimetableEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTimetableEvent>>,
        TError,
        DeleteTimetableEventMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTimetableEventMutationOptions(options), queryClient);
    }
    /**
 * Returns details of a specific event
 * @summary Get a specific event
 */
export const getTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<TimetableEvent>(
      {url: `/timetable/calendars/${calendarId}/events/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetTimetableEventQueryKey = (calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'timetable','calendars',calendarId,'events',id
    ] as const;
    }


export const getGetTimetableEventQueryOptions = <TData = Awaited<ReturnType<typeof getTimetableEvent>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimetableEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetTimetableEventQueryKey(calendarId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimetableEvent>>> = ({ signal }) => getTimetableEvent(calendarId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimetableEvent>>, TError, TData>
}

export type GetTimetableEventQueryResult = NonNullable<Awaited<ReturnType<typeof getTimetableEvent>>>
export type GetTimetableEventQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get a specific event
 */

export function useGetTimetableEvent<TData = Awaited<ReturnType<typeof getTimetableEvent>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimetableEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimetableEventQueryOptions(calendarId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Update attributes of a timetable event
 * @summary Update a timetable event
 */
export const updateTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    timetableEventUpdateInput?: MaybeRefOrGetter<TimetableEventUpdateInput>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);
timetableEventUpdateInput = toValue(timetableEventUpdateInput);

      return axiosClient<TimetableEvent>(
      {url: `/timetable/calendars/${calendarId}/events/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: timetableEventUpdateInput, signal
    },
      );
    }




export const getUpdateTimetableEventMutationKey = () => ['updateTimetableEvent'] as const;

export const getUpdateTimetableEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimetableEvent>>, TError,UpdateTimetableEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTimetableEvent>>, TError,UpdateTimetableEventMutationVariables, TContext> => {

const mutationKey = getUpdateTimetableEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTimetableEvent>>, UpdateTimetableEventMutationVariables> = (props) => {
          const {calendarId,id,data} = props ?? {};

          return  updateTimetableEvent(calendarId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTimetableEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateTimetableEvent>>>
    export type UpdateTimetableEventMutationBody = TimetableEventUpdateInput | undefined
    export type UpdateTimetableEventMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateTimetableEventMutationVariables = {calendarId: string;id: string;data?: TimetableEventUpdateInput}

    /**
 * @summary Update a timetable event
 */
export const useUpdateTimetableEvent = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimetableEvent>>, TError,UpdateTimetableEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateTimetableEvent>>,
        TError,
        UpdateTimetableEventMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTimetableEventMutationOptions(options), queryClient);
    }
    /**
 * Mark one internal timetable event occurrence as cancelled without removing its content
 * @summary Cancel timetable event
 */
export const cancelTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/events/${id}/cancel`, method: 'POST', signal
    },
      );
    }




export const getCancelTimetableEventMutationKey = () => ['cancelTimetableEvent'] as const;

export const getCancelTimetableEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTimetableEvent>>, TError,CancelTimetableEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelTimetableEvent>>, TError,CancelTimetableEventMutationVariables, TContext> => {

const mutationKey = getCancelTimetableEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTimetableEvent>>, CancelTimetableEventMutationVariables> = (props) => {
          const {calendarId,id} = props ?? {};

          return  cancelTimetableEvent(calendarId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelTimetableEventMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTimetableEvent>>>

    export type CancelTimetableEventMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CancelTimetableEventMutationVariables = {calendarId: string;id: string}

    /**
 * @summary Cancel timetable event
 */
export const useCancelTimetableEvent = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTimetableEvent>>, TError,CancelTimetableEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelTimetableEvent>>,
        TError,
        CancelTimetableEventMutationVariables,
        TContext
      > => {
      return useMutation(getCancelTimetableEventMutationOptions(options), queryClient);
    }
    /**
 * End an internal course or event series from the selected occurrence
 * @summary Discontinue timetable event series
 */
export const discontinueTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/events/${id}/discontinue`, method: 'POST', signal
    },
      );
    }




export const getDiscontinueTimetableEventMutationKey = () => ['discontinueTimetableEvent'] as const;

export const getDiscontinueTimetableEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discontinueTimetableEvent>>, TError,DiscontinueTimetableEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof discontinueTimetableEvent>>, TError,DiscontinueTimetableEventMutationVariables, TContext> => {

const mutationKey = getDiscontinueTimetableEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discontinueTimetableEvent>>, DiscontinueTimetableEventMutationVariables> = (props) => {
          const {calendarId,id} = props ?? {};

          return  discontinueTimetableEvent(calendarId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscontinueTimetableEventMutationResult = NonNullable<Awaited<ReturnType<typeof discontinueTimetableEvent>>>

    export type DiscontinueTimetableEventMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DiscontinueTimetableEventMutationVariables = {calendarId: string;id: string}

    /**
 * @summary Discontinue timetable event series
 */
export const useDiscontinueTimetableEvent = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discontinueTimetableEvent>>, TError,DiscontinueTimetableEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof discontinueTimetableEvent>>,
        TError,
        DiscontinueTimetableEventMutationVariables,
        TContext
      > => {
      return useMutation(getDiscontinueTimetableEventMutationOptions(options), queryClient);
    }
    /**
 * Returns the number of events affected by ending a course or event series
 * @summary Preview discontinued timetable events
 */
export const previewDiscontinueTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<TimetableEventDiscontinuePreview>(
      {url: `/timetable/calendars/${calendarId}/events/${id}/discontinue_preview`, method: 'GET', signal
    },
      );
    }




export const getPreviewDiscontinueTimetableEventQueryKey = (calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'timetable','calendars',calendarId,'events',id,'discontinue_preview'
    ] as const;
    }


export const getPreviewDiscontinueTimetableEventQueryOptions = <TData = Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPreviewDiscontinueTimetableEventQueryKey(calendarId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>> = ({ signal }) => previewDiscontinueTimetableEvent(calendarId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>, TError, TData>
}

export type PreviewDiscontinueTimetableEventQueryResult = NonNullable<Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>>
export type PreviewDiscontinueTimetableEventQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Preview discontinued timetable events
 */

export function usePreviewDiscontinueTimetableEvent<TData = Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewDiscontinueTimetableEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewDiscontinueTimetableEventQueryOptions(calendarId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Asynchronously pushes the event's lesson topic to Untis. Status is broadcast via ActionCable.
 * @summary Push lesson topic to external system
 */
export const pushTimetableEventToExternal = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/events/${id}/push_to_external`, method: 'POST', signal
    },
      );
    }




export const getPushTimetableEventToExternalMutationKey = () => ['pushTimetableEventToExternal'] as const;

export const getPushTimetableEventToExternalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTimetableEventToExternal>>, TError,PushTimetableEventToExternalMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pushTimetableEventToExternal>>, TError,PushTimetableEventToExternalMutationVariables, TContext> => {

const mutationKey = getPushTimetableEventToExternalMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushTimetableEventToExternal>>, PushTimetableEventToExternalMutationVariables> = (props) => {
          const {calendarId,id} = props ?? {};

          return  pushTimetableEventToExternal(calendarId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushTimetableEventToExternalMutationResult = NonNullable<Awaited<ReturnType<typeof pushTimetableEventToExternal>>>

    export type PushTimetableEventToExternalMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type PushTimetableEventToExternalMutationVariables = {calendarId: string;id: string}

    /**
 * @summary Push lesson topic to external system
 */
export const usePushTimetableEventToExternal = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushTimetableEventToExternal>>, TError,PushTimetableEventToExternalMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushTimetableEventToExternal>>,
        TError,
        PushTimetableEventToExternalMutationVariables,
        TContext
      > => {
      return useMutation(getPushTimetableEventToExternalMutationOptions(options), queryClient);
    }
    /**
 * Restore one cancelled internal timetable event occurrence
 * @summary Restore timetable event
 */
export const restoreTimetableEvent = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/events/${id}/restore`, method: 'POST', signal
    },
      );
    }




export const getRestoreTimetableEventMutationKey = () => ['restoreTimetableEvent'] as const;

export const getRestoreTimetableEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreTimetableEvent>>, TError,RestoreTimetableEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof restoreTimetableEvent>>, TError,RestoreTimetableEventMutationVariables, TContext> => {

const mutationKey = getRestoreTimetableEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreTimetableEvent>>, RestoreTimetableEventMutationVariables> = (props) => {
          const {calendarId,id} = props ?? {};

          return  restoreTimetableEvent(calendarId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreTimetableEventMutationResult = NonNullable<Awaited<ReturnType<typeof restoreTimetableEvent>>>

    export type RestoreTimetableEventMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RestoreTimetableEventMutationVariables = {calendarId: string;id: string}

    /**
 * @summary Restore timetable event
 */
export const useRestoreTimetableEvent = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreTimetableEvent>>, TError,RestoreTimetableEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof restoreTimetableEvent>>,
        TError,
        RestoreTimetableEventMutationVariables,
        TContext
      > => {
      return useMutation(getRestoreTimetableEventMutationOptions(options), queryClient);
    }
